export default {
  shippingDetails: {
    id: 'bo_sellers-orders-drawers-ship_order-shipping_details',
    defaultMessage: 'Shipping details',
  },
  shippingInfoText: {
    id: 'bo_sellers-orders-drawers-ship_order-shipping_info_text',
    defaultMessage:
      'The shipping speed and price must match what your customer chose when they placed the order.',
  },
  carriers: {
    id: 'bo_sellers-orders-drawers-ship_order-shipping_provider',
    defaultMessage: 'Shipping provider',
  },
  trackingNumber: {
    id: 'bo_sellers-orders-drawers-ship_order-tracking_number',
    defaultMessage: 'Tracking number',
  },
  enterIMEI: {
    id: 'bo_sellers-orders-drawers-ship_order-enter_imei',
    defaultMessage: `Enter {imei, plural,
      one {the IMEI}
      other {IMEIs}
    }`,
  },
  enterSerialNumber: {
    id: 'bo_sellers-orders-drawers-ship_order-enter_serial_number',
    defaultMessage: `Enter serial {number, plural,
      one {number}
      other {numbers}
    } (optional)`,
  },
  orderLineItem: {
    id: 'bo_sellers-orders-drawers-ship_order-order_line_item',
    defaultMessage: 'Order line item',
  },
  sku: {
    id: 'bo_sellers-orders-drawers-ship_order-sku',
    defaultMessage: 'SKU',
  },
  imei: {
    id: 'bo_sellers-orders-drawers-ship_order-imei',
    defaultMessage: 'IMEI',
  },
  serialNumber: {
    id: 'bo_sellers-orders-drawers-ship_order-serial_number',
    defaultMessage: 'Serial number',
  },
  learnWhyIMEI: {
    id: 'bo_sellers-orders-drawers-ship_order-learn_why_imei',
    defaultMessage: 'Learn why an IMEI is required',
  },
  shipItem: {
    id: 'bo_sellers-orders-drawers-ship_order-ship_item',
    defaultMessage: `Ship {item, plural,
      one {item}
      other {items}
    } `,
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-ship_order-cancel',
    defaultMessage: 'Cancel',
  },
  orderProcessed: {
    id: 'bo_sellers-orders-drawers-ship_order-order_processed',
    defaultMessage: 'Order {orderId} processed.',
  },
  loading: {
    id: 'bo_sellers-orders-drawers-ship_order-fetching_data',
    defaultMessage: 'We are fetching your data',
  },
  required: {
    id: 'bo_sellers-orders-drawers-ship_order-required',
    defaultMessage: 'This field is required',
  },
  selectYourVatRegime: {
    id: 'bo_sellers-orders-drawers-ship_order-select_vat',
    defaultMessage: 'Select your VAT regime',
  },
  uploadReceipt: {
    id: 'bo_sellers-orders-drawers-ship_order-upload_receipt',
    defaultMessage: 'Upload receipt (optionnal)',
  },
} as const
